import { createContext, useEffect, useState, useContext } from 'react';

import axios from 'axios';
import { useContainer } from 'unstated-next';

import { type ClassSessionUser } from './types';
import { GET_CLASS_SESSION_ZOOM_STATES } from '../../../../config/apiPaths';
import { getUserUuidHeaders } from '../../../../utils/httpUtils';
import { processApiPath } from '../../../../utils/url';
import AdminAuthContainer from '../../AdminAuthContainer';
import { ClassSessionContext } from '../../ClassSessionContext';

interface ClassSessionUsersContextInterface {
    isLoading: boolean;
    classSessionUsers: ClassSessionUser[];
    allLoaded: boolean;
}

const ClassSessionUsersContext = createContext(undefined as unknown as ClassSessionUsersContextInterface);

const { Provider, Consumer } = ClassSessionUsersContext;

const ClassSessionUsersProvider = ({ classSessionUuid, children }) => {
    const { classSessionReportingEvents } = useContext(ClassSessionContext);

    const search = new URLSearchParams(window.location.search);
    const userUuid = search.get('user_uuid') || window.localStorage.getItem('user_uuid');

    const { authMode, showDemoContent } = useContainer(AdminAuthContainer);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [allLoaded, setAllLoaded] = useState<boolean>(false);
    const [classSessionUsers, setClassSessionUsers] = useState<any[]>([]);

    useEffect(() => {
        const loadInner = async () => {
            console.log('isLoading', isLoading);
            if (classSessionReportingEvents.loading || !isLoading || allLoaded) {
                return;
            }
            const { data: responseData } = await axios.get(
                processApiPath(GET_CLASS_SESSION_ZOOM_STATES, undefined, {
                    auth_mode: authMode,
                    demo_content: String(showDemoContent),
                    class_session_uuid: classSessionUuid
                }),
                { headers: getUserUuidHeaders(userUuid as string) }
            );
            const { data } = responseData.response_too_large_url
                ? await axios.get(responseData.response_too_large_url)
                : { data: responseData };

            data.forEach((item) => {
                item.reportingEvents = [];
                classSessionReportingEvents.items.forEach((event) => {
                    if (item.zoomstate_uuid === event.zoomstate_uuid) {
                        item.reportingEvents.push(event);
                    }
                });
            });
            setClassSessionUsers(data);
            setIsLoading(false);
            setAllLoaded(true);
        };
        loadInner();
    }, [
        authMode,
        classSessionUuid,
        userUuid,
        showDemoContent,
        isLoading,
        allLoaded,
        setClassSessionUsers,
        setAllLoaded,
        classSessionReportingEvents
    ]);

    return (
        <Provider
            value={{
                classSessionUsers,
                isLoading,
                allLoaded
            }}
        >
            {children}
        </Provider>
    );
};

export { ClassSessionUsersContext, ClassSessionUsersProvider, Consumer as ClassSessionUsersConsumer };
